import { render, staticRenderFns } from "./VolunteerSchedule.vue?vue&type=template&id=ec948dee&scoped=true"
import script from "./VolunteerSchedule.vue?vue&type=script&lang=js"
export * from "./VolunteerSchedule.vue?vue&type=script&lang=js"
import style0 from "./VolunteerSchedule.vue?vue&type=style&index=0&id=ec948dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec948dee",
  null
  
)

export default component.exports